import React, { useEffect, useState, type FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import LoadingView from '../components/LoadingView';
import api from '../services/api';
import ChartCompareTable from '../components/ChartCompareTable';
import type CycleCompareSymptoms from '../models/CycleCompareSymptomsModel';
import ChartCompareKey from '../components/ChartCompareKey';

const ChartCompare: FC = () => {
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(true);
    const [cycleCompareSymptoms, setCycleCompareSymptoms] =
        useState<CycleCompareSymptoms>([]);
    const [algorithm, setAlgorithm] = useState<'st' | 'marquette'>('st');

    const [parameters] = useSearchParams();
    const userId = Number(parameters.get('id'));
    const cycleStart = parameters.get('start') ?? '';

    useEffect(() => {
        const pullStudentCycleHistory = async () => {
            const { cycleCompareSymptoms, algorithm, success, error } =
                await api.getStudentCycleCompareSymptoms(userId, cycleStart);
            setCycleCompareSymptoms(cycleCompareSymptoms);
            setAlgorithm(algorithm);
            if (!success) {
                setErrorMessage(error ?? 'unknown error');
            }

            setLoading(false);
        };

        void pullStudentCycleHistory();
    }, [userId, cycleStart]);

    return (
        <>
            <div className="text-primary text-3xl pb-4">
                Chart Compare for {cycleStart} Cycle
            </div>
            {loading && <LoadingView />}
            {!loading && errorMessage && (
                <div className="text-primary text-xl">
                    Error: {errorMessage}
                </div>
            )}
            {!loading && !errorMessage && (
                <>
                    <div className="text-primary">
                        {algorithm === 'marquette'
                            ? 'Comparative analysis of six cycles showing menses, fertility monitor and peak day.'
                            : 'Comparative analysis of six cycles showing menses, more fertile mucus, and peak day.'}
                    </div>
                    <ChartCompareKey algorithm={algorithm} />
                    <ChartCompareTable
                        cycleCompareSymptoms={cycleCompareSymptoms}
                        algorithm={algorithm}
                    />
                </>
            )}
        </>
    );
};

export default ChartCompare;
